import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Monogram } from "@/components/site/Header";

export default function AdminLogin() {
  const { login, user } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1D3324] grain relative flex items-center justify-center p-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="relative w-full max-w-md bg-[#F8F5EE] p-8 sm:p-10 shadow-2xl">
        <Monogram className="!h-12 !w-14 !text-[#1D3324]" />
        <h1 className="f-display mt-6 text-3xl">Panel de administración</h1>
        <p className="mt-2 text-sm text-[#5C635E]">Hacienda Fernández &amp; Vargas</p>
        <div className="mt-8 space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" className="h-12 bg-white" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" className="h-12 bg-white" />
          </div>
          {error && <p className="text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit-button" className="btn-fv btn-red w-full justify-center disabled:opacity-60">
            {busy ? "Ingresando…" : "Ingresar"}
          </button>
        </div>
        <Link to="/" className="mt-6 block text-center text-sm text-[#5C635E] hover:text-[#8B2B22]" data-testid="admin-login-back-link">← Volver al sitio</Link>
      </form>
    </div>
  );
}
